import React from 'react';
import PropTypes from 'prop-types';

import { useAnalytics } from '@Shared/useAnalytics';
import { IsPurchaseProcess } from '../utilities';
import {
  Wrapper,
  Price,
  CarImageOuterWrapper,
  CarImageWrapper,
  CarImageInnerWrapper,
  CarImage,
  Title,
  Button,
  DollarSign
} from './Account/PurchaseCard.styles';

const getFormattedPrice = price => {
  const priceWithoutDecimals = Math.round(price).toLocaleString('en');
  return priceWithoutDecimals;
};

const generateButtonInfo = (text, url) => ({ text, url });

const getButtonAttributes = ({ orderState, stockNumber, vehicleId }) => {
  if (IsPurchaseProcess()) {
    return generateButtonInfo('Vehicle Details', `/vehicle/${vehicleId}`);
  }

  if (orderState === 'Reserved') {
    return generateButtonInfo('Continue Pre-Order', `/vehicle/${vehicleId}`);
  }

  return generateButtonInfo(
    'Continue Purchase',
    `/purchase/dashboard?stock-number=${stockNumber}`
  );
};

const PurchaseInProgressCard = ({ className, purchaseDetails }) => {
  const {
    stockNumber,
    year,
    make,
    model,
    totalPrice,
    inventoryType
  } = purchaseDetails;
  const { trackEventAndGo } = useAnalytics();
  const formattedPrice = getFormattedPrice(totalPrice);
  const imageSource = `${process.env.FASTLY_CDNBLOB_URL}/${stockNumber}/post-large/${stockNumber}-edc-02-search.jpg?width=250`;
  const { text: buttonText, url: buttonUrl } = getButtonAttributes(purchaseDetails);
  const isWIPVehicle = inventoryType === 'WIP';

  return (
    <Wrapper data-cv-test="headerPurchaseWidget" className={className}>
      <CarImageOuterWrapper>
        <Price>
          <DollarSign>$</DollarSign>
          {formattedPrice}
        </Price>
        {!isWIPVehicle &&
          <CarImageWrapper>
            <CarImageInnerWrapper>
              <CarImage src={imageSource} alt="Car" />
            </CarImageInnerWrapper>
          </CarImageWrapper>
        }
      </CarImageOuterWrapper>
      <Title>{`${year} ${make} ${model}`}</Title>
      <Button
        data-cv-test="headerPurchaseLink"
        target="_self"
        href={buttonUrl}
        onClick={e => trackEventAndGo(e, 'clicked purchase widget')}
      >
        {buttonText}
      </Button>
    </Wrapper>
  );
};

PurchaseInProgressCard.defaultProps = {
  className: ''
};

PurchaseInProgressCard.propTypes = {
  purchaseDetails: PropTypes.shape({}).isRequired,
  className: PropTypes.string
};

export default PurchaseInProgressCard;
